import 'angular';
import Features from '../feature-manager/Features';
var Netmask = require('netmask').Netmask;
import {Constants} from '@amzn/aws-workdocs-web-client-common';

    function PurgeDocumentVersionController($scope, $timeout, $log, $uibModal, PurgeVersionService, MessageProvider, MessageManager) {

    $scope.purge = {
        purgeVersionConfirmationText: "",
        isPurgeButtonDisabled: true,
        deletePreviousVersions: false
    };

    var CONFIRMATION_TEXT_PURGE = "PURGE";
    var PURGE_PRIOR_VERSIONS_WAIT_TIME = 2000;

    /*Deleting single version*/

    $scope.deleteDocumentVersion = function() {
        if($scope.purge.isPurgeButtonDisabled){
            $log.info('purge button is not enabled, not doing anything');
            return;
        }
        $scope.$close(true);
        $log.info('Calling purge version on document: ' + $scope.metadata.Id + ' version: ' + $scope.documentState.activeVersion.VersionId);
        PurgeVersionService.deleteDocumentVersion($scope.metadata.Id, $scope.documentState.activeVersion.VersionId)
        .success(function() {

            $scope.getDocument();

            $timeout(function() {
                MessageManager.addSuccessMessage(MessageProvider.documentVersionDeleteSuccess);
            }, 0);
        })
        .error(function(data, status, headers, config) {
             if(status == 405){
                $log.error('Attempted to delete first document version');
                MessageManager.addErrorMessage(MessageProvider.documentVersionDeleteFirstFail);
             } else {
                $log.error('Unable to delete document version');
                MessageManager.addErrorMessage(MessageProvider.documentVersionDeleteFail);
            }
        });
    };

    /*Deleting multiple versions*/

     $scope.deletePriorDocumentVersions = function() {
        if($scope.purge.isPurgeButtonDisabled){
            $log.info('purge button is not enabled, not doing anything');
            return;
        }
        $scope.$close(true);
        $log.info('Calling purge all prior versions on document: ' + $scope.metadata.Id + ' version: ' + $scope.documentState.activeVersion.VersionId);
        PurgeVersionService.deletePriorDocumentVersions($scope.metadata.Id, $scope.documentState.activeVersion.VersionId)
        .success(function() {


            // deleteDocumentVersion() API call when deleting prior versions happens Asynchronously, all DDB entries will be deleted after the call returns a 200, therefore some sort of delay is needed if we are refreshing the page otherwise
            // we will need to redirect back to the root folder, however if they click back, this problem will still be apparent until full async deletion has completed. Will be apparent with large quantity of versions being deleted
            $timeout(function() {
                $scope.getDocument();
            }, PURGE_PRIOR_VERSIONS_WAIT_TIME);

            $timeout(function() {
                MessageManager.addSuccessMessage(MessageProvider.documentVersionsDeleteSuccess);
            }, 0);
        })
        .error(function(data, status, headers, config) {
            if(status == 405){
                $log.error('Attempted to delete first document version');
                MessageManager.addErrorMessage(MessageProvider.documentVersionDeleteFirstFail);
            } else {
                $log.error('Unable to delete prior document versions');
                MessageManager.addErrorMessage(MessageProvider.documentVersionsDeleteFail);
            }
        });
     };

    $scope.deleteDocumentVersions = function() {
        $scope.$close(true);
        $log.info('Calling version delete on document: ' + $scope.metadata.Id + ' version: ' + $scope.modals.purgeVersionId + ' with deletePreviousVersion choice as ' + $scope.purge.deletePreviousVersions);
        PurgeVersionService.deleteDocumentVersions($scope.metadata.Id, $scope.modals.purgeVersionId, $scope.purge.deletePreviousVersions)
            .success(function() {
                $timeout(function() {
                    $scope.getDocument();
                }, PURGE_PRIOR_VERSIONS_WAIT_TIME);
                $timeout(function() {
                    MessageManager.addSuccessMessage(MessageProvider.documentVersionsDeleteSuccess);
                }, 0);
            })
            .error(function(data, status, headers, config) {
                if(status == 405){
                    $log.error('Attempted to delete first document version');
                    MessageManager.addErrorMessage(MessageProvider.documentVersionDeleteFirstFail);
                } else {
                    $log.error('Unable to delete prior document versions');
                    MessageManager.addErrorMessage(MessageProvider.documentVersionsDeleteFail);
                }
            });
    }

    /*Helper methods*/

    $scope.isPurgeConfirmationMet = function () {
        $scope.purge.isPurgeButtonDisabled = $scope.purge.purgeVersionConfirmationText != CONFIRMATION_TEXT_PURGE;
        return $scope.purge.isPurgeButtonDisabled;
    };

    //False means the button is active
    $scope.getPurgeButtonStatus = function () {
        return $scope.purge.isPurgeButtonDisabled;
    };

}

    PurgeDocumentVersionController.$inject = ['$scope', '$timeout', '$log','$uibModal', 'PurgeVersionService', 'MessageProvider', 'MessageManager'];

    angular.module('GorillaBoy.services')
        .controller('PurgeDocumentVersionController', PurgeDocumentVersionController);